import DOMUtils from "@utils/dom.utils";

export default {
  SELECTOR: {
    STUDENT_TOOLTIP: ".student-tooltip",
    STUDENT_TOOLTIP_TAG: ".student-tooltip:not(.student-tooltip-component)",
    STUDENT_TOOLTIP_COMPONENT: ".student-tooltip.student-tooltip-component",
    STUDENT_TOOLTIP_COMPONENT_WRAPPER: ".sls-student-tooltip-wrapper",
  },

  /**
   * Function to create student tooltip tag.
   * @param tooltipData
   * @returns {HTMLElement}
   */
  createStudentTooltipTag(tooltipData) {
    let tooltipNoteTitle = tooltipData.title;
    let tooltipNoteContent = tooltipData.content;

    let tooltipTagElement = document.createElement("span");
    tooltipTagElement.setAttribute("class", "student-tooltip");
    tooltipTagElement.setAttribute("data-note-title", tooltipNoteTitle);
    tooltipTagElement.setAttribute("data-note-content", tooltipNoteContent);

    return tooltipTagElement;
  },

  /**
   * Function extract the student tooltip data from student tooltip tag and component.
   * @param element
   * @returns {*}
   */
  retrieveDataFromStudentTooltip(element) {
    if (notDefined(element) || isNull(element)) {
      return {};
    }

    const data = {
      title: element.getAttribute("data-note-title"),
      content: element.getAttribute("data-note-content"),
    };

    return data;
  },

  /**
   * Function to retrieve the first Student Tooltip in editor's selection.
   * @param editor
   * @returns {*}
   */
  retrieveFirstSelectedStudentTooltipFromEditor(editor) {
    // find in selection start
    const selectionStart = editor.selection.getStart();
    if (DOMUtils.hasClass(selectionStart, "sls-student-tooltip-wrapper")) {
      return DOMUtils.elOf(selectionStart, this.SELECTOR.STUDENT_TOOLTIP_COMPONENT)[0];
    }

    // find in selection content
    const selection = editor.selection.getSel();
    const container = editor.selection.getNode();
    const tooltipInSelection = DOMUtils.elOf(
      container,
      this.SELECTOR.STUDENT_TOOLTIP_COMPONENT,
    ).filter((node) => {
      return selection.containsNode(node);
    });
    if (tooltipInSelection.length !== 0) {
      return tooltipInSelection[0];
    }

    // find in selection end
    const selectionEnd = editor.selection.getEnd();
    if (DOMUtils.hasClass(selectionEnd, "sls-student-tooltip-wrapper")) {
      return DOMUtils.elOf(selectionEnd, this.SELECTOR.STUDENT_TOOLTIP_COMPONENT)[0];
    }

    // no selection or student tooltip not in selection
    return null;
  },
};
